export default __webpack_public_path__ + "static/media/fees-img.302553ce.svg";